// Define the supported languages
export const SUPPORTED_LANGUAGES = {
  vi: { name: 'Tiếng Việt', code: 'vi', flag: '🇻🇳' },
  en: { name: 'English', code: 'en', flag: '🇺🇸' },
};
